<div
  class="w-full"
  [tooltip]="
    disabled()
      ? 'Discount codes are not available while the selected upgrade is active'
      : ''
  "
  placement="top"
  triggers="mouseenter:mouseleave">
  @if (hasDiscount) {
    <div class="flex items-center justify-between gap-2">
      <span
        class="rounded-full bg-[#4c8e42]/10 px-4 py-1.5 text-xs font-bold text-[#4c8e42]"
        data-cy="discount-code-applied">
        Code: {{ appliedCode }}
      </span>
      <button
        type="button"
        data-cy="remove-discount-code-button"
        class="text-[#4c8e42] hover:text-[#3c7134] font-bold text-lg leading-none"
        [disabled]="isLoading()"
        (click)="remove()"
        aria-label="Remove discount code">
        &times;
      </button>
    </div>
  } @else {
    <div class="flex gap-2">
      <input
        type="text"
        data-cy="discount-code-input"
        class="min-w-0 flex-1 rounded-full border border-[#d2d2d2] px-4 py-1.5 text-xs font-medium text-[#404041] placeholder:text-[#767676]/50 placeholder:font-medium focus:outline-none focus:ring-2 focus:ring-gray-900"
        placeholder="Discount code?"
        [(ngModel)]="code"
        [disabled]="isLoading() || disabled()"
        (keyup.enter)="apply()" />
      <button
        type="button"
        data-cy="apply-discount-code-button"
        class="shrink-0 whitespace-nowrap rounded-full bg-black px-4 py-1.5 text-xs font-bold text-white hover:scale-95 transition-transform disabled:opacity-50 disabled:hover:transform-none"
        [disabled]="isLoading() || !code().trim() || disabled()"
        (click)="apply()">
        @if (isLoading()) {
          Applying...
        } @else {
          Apply
        }
      </button>
    </div>
  }

  @if (errorMessage(); as msg) {
    <p
      class="mt-2 text-xs font-medium text-red text-center"
      data-cy="discount-code-error">
      {{ msg }}
    </p>
  }
</div>
